import logomachine from './logomachine.png'

const images = {
    logomachine,
}

export default images